import React from 'react';
import { VStack } from '@chakra-ui/react';
import { RiftboundButton } from '../ui/button';
import { GoogleIcon } from './SignInIcons';

interface SignInButtonsProps {
  onSignIn: (provider: string) => void;
}

export const SignInButtons: React.FC<SignInButtonsProps> = ({ onSignIn }) => (
  <VStack w="full" gap={3}>
    <RiftboundButton w="full" onClick={() => onSignIn('google')} treatment="secondary" size="lg">
      <GoogleIcon />
      Continue with Google
    </RiftboundButton>
  </VStack>
);
